import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Camera, BookOpen, Calendar, ShoppingCart } from 'lucide-react';

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/upload', icon: Camera, label: 'Add' },
    { path: '/library', icon: BookOpen, label: 'Library' },
    { path: '/calendar', icon: Calendar, label: 'Calendar' },
    { path: '/shopping-list', icon: ShoppingCart, label: 'List' },
  ];

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 bg-white border-t safe-area-bottom z-50"
      style={{
        borderTopColor: '#f3f4f6',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.05)',
      }}
    >
      <div className="max-w-md mx-auto flex justify-around px-2 py-3">
        {navItems.map(({ path, icon: Icon, label }) => {
          const active = isActive(path);
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={`flex flex-col items-center py-2 px-3 min-w-0 flex-1 rounded-xl transition-all ${
                active ? 'bg-purple-50' : 'hover:bg-gray-50'
              }`}
            >
              <Icon 
                size={24} 
                className={active ? 'text-purple-600' : 'text-gray-400'}
                strokeWidth={2}
              />
              <span 
                className={`text-xs mt-1.5 ${
                  active 
                    ? 'font-semibold text-purple-600' 
                    : 'text-gray-500 font-medium'
                }`}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
